import * as React from 'react';
import { getStringTable } from '../../utilities/localizationUtilities';
import { HostAppColors } from '../styles/HostAppColors';
import { Locale } from '@fluidx/utilities';

export interface ErrorBoundaryState {
  /**
   * The JSX Element that holds the error dialog
   */
  errorDialog?: JSX.Element;
}

export interface ErrorBoundaryProps {
  /**
   * Host locale
   */
  locale: Locale;
  /**
   * The host app colors
   */
  appColors: HostAppColors;
}

export class ErrorBoundary extends React.PureComponent<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = {};

  render() {
    if (this.state.errorDialog) {
      return this.state.errorDialog;
    }

    return this.props.children;
  }

  // TODO: UIHOST: Log an error here when we have the telemetry story sorted
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    import(/* webpackChunkName: "errorDialog", webpackPrefetch: true */ './ErrorDialog').then((m) => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      getStringTable(this.props.locale).then((table) =>
        this.setState({
          errorDialog: (
            <m.ErrorDialog
              dialogStrings={{
                dialogTitle: table.errorDialogTitle,
                dialogMessage: table.genericErrorMessage
              }}
              appColors={this.props.appColors}
              actions={[
                {
                  type: 'Default',
                  label: table.close
                }
              ]}
              debugInfo={{
                debugErrorCode: table.errorBoundary,
                debugError: error,
                debugReactErrorBoundaryInfo: errorInfo
              }}
            />
          )
        })
      );
    });
  }
}
